// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"Hamburger_hamburger__jobw2","slice":"Hamburger_slice__11Vvq","slice--light":"Hamburger_slice--light__3Y_xS","slice--dark":"Hamburger_slice--dark__2YuLu"};